import styled, { css } from 'styled-components/macro';

import { ReactComponent as CalendarSvg } from 'components/svg/Calendar.svg';
import { large } from 'styles/breakpoints';
import { container } from 'styles/layout';
import {
  description,
  heading,
  input,
  mapEtaLabel,
  paragraph,
} from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const Container = styled.div`
  ${container}

  margin: 50px auto 0;

  ${large`
    width: 520px;
  `}
`;

export const Header = styled.h2`
  ${heading}

  & {
    margin: 26px 0;
  }

  ${({ theme }: IWithThemeProps) => css`
    color: ${theme.topForegroundPrimary};
  `}
`;

export const EnterpriseDetails = styled.div`
  margin: 0 15px 60px;
`;

export const EnterpriseDescription = styled.p`
  ${paragraph};

  margin-bottom: 30px;
  text-align: left;

  ${({ theme }: IWithThemeProps) => css`
    color: ${theme.topForegroundPrimary};
  `}
`;

export const PreferredPartnerLabel = styled.p`
  ${paragraph};

  margin: 0 0 8px;
  text-align: left;

  ${({ theme }: IWithThemeProps) => css`
    color: ${theme.topForegroundPrimary};
  `}
`;

export const PreferredPartner = styled.div`
  border-radius: 6px;
  padding: 9px 12px 9px;
  text-align: left;

  ${({ theme }: IWithThemeProps) => css`
    border: 1px solid ${theme.topForegroundPrimary};
  `}
`;

export const PreferredPartnerName = styled.p`
  ${mapEtaLabel};

  margin: 0;

  ${({ theme }: IWithThemeProps) => css`
    color: ${theme.topForegroundPrimary};
  `}
`;

export const PreferredPartnerAddress = styled.p`
  ${description};

  color: ${({ theme }) => theme.topForegroundPrimary};
  display: block;
  margin: 2px 0 0;
  text-align: left;
`;

export const SummaryDetails = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  margin: 0 0 35px;

  ${large`
    flex-direction: row;
  `}
`;

export const SummaryItems = styled.div`
  list-style: none;
  padding: 0 14px;
  text-align: left;

  ${large`
    align-items: flex-start;
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    justify-content: center;
    padding: 0;
    /* Fixes IE 10 issue where text would not wrap */
    width: 290px;
  `}
`;

export const SummaryItem = styled.p`
  ${input}

  align-items: center;
  display: flex;
  line-height: 24px;
  margin: 20px 0 14px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}

  ${large`
    margin-top: 11px;
  `}
`;

export const SummaryImage = styled(CalendarSvg)`
  height: 24px;
  margin-right: 10px;
  width: 21px;
`;

export const Description = styled.p`
  ${paragraph}

  flex: 0 1 auto;
  margin: 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}

  > span > b {
    text-transform: uppercase;
  }
`;

export const Logo = styled.img`
  margin-top: 20px;
  max-height: 120px;
  max-width: 230px;
  padding: 0 20px;

  ${large`
    max-height: 150px;
    padding: 0 20px;
  `}
`;
